import { render } from "./ErrorMessageIcon.vue?vue&type=template&id=e1bd7c28&scoped=true"
const script = {}

import "./ErrorMessageIcon.vue?vue&type=style&index=0&id=e1bd7c28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1bd7c28"]])

export default __exports__